import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/arrows/decor-arrow-1.svg")